import { __assign } from "tslib";
import { parseConfig } from '@office-start/config-parser-utility';
import { isUwp, isWebView2 } from '@office-start/device-detection-utility';
import { OfficeWorkload } from '@office-start/officehome-types';
var userEntitlementsKey = 'userEntitlements';
export function readUserEntitlements(identity, workload) {
    var domUserEntitlements = parseConfig(userEntitlementsKey);
    var isPwa = workload === OfficeWorkload.Hwa;
    var isPwaInUwp = isPwa && isUwp();
    var isPwaInWebView2 = isPwa && isWebView2();
    return __assign(__assign({}, domUserEntitlements), { isCommercialUser: !identity.isMsa, isConsumerUser: identity.isMsa, isEmbed: workload === OfficeWorkload.Embed, isPwa: isPwa, isPwaInUwp: isPwaInUwp, isPwaInWebView2: isPwaInWebView2 });
}
//# sourceMappingURL=readUserEntitlements.js.map